var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#0CBA63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1082 8.77551L19.4007 11.3605C19.5748 11.718 20.0423 12.0572 20.4365 12.1305L22.774 12.5155C24.2682 12.763 24.6165 13.8447 23.544 14.9263L21.7198 16.7505C21.4173 17.053 21.2432 17.6488 21.344 18.0797L21.8665 20.3347C22.279 22.113 21.3257 22.8097 19.7582 21.8747L17.5673 20.573C17.1732 20.3347 16.5132 20.3347 16.119 20.573L13.9282 21.8747C12.3607 22.8005 11.4074 22.113 11.8199 20.3347L12.3424 18.0797C12.4432 17.658 12.269 17.0622 11.9665 16.7505L10.1424 14.9263C9.06986 13.8538 9.41819 12.7722 10.9124 12.5155L13.2499 12.1305C13.644 12.0663 14.1115 11.718 14.2857 11.3605L15.5782 8.77551C16.2657 7.37301 17.4024 7.37301 18.1082 8.77551Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 8.58301H5.83398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58398 21.417H5.83398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75065 15H5.83398",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftStar);
export default __webpack_public_path__ + "static/media/GiftStar.bddf92fc984decd4cb528fa60fd27346.svg";
export { ForwardRef as ReactComponent };